module.exports = "./img/f84cab91f59fce810bfd23e576471bae.jpg";